var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#05262c",
    fillRule: "nonzero",
    d: "M11.034 14.136L.385 3.487a1.315 1.315 0 0 1 0-1.86L1.627.385A1.315 1.315 0 0 1 3.485.383l8.479 8.44 8.48-8.44A1.315 1.315 0 0 1 22.3.385l1.242 1.242a1.315 1.315 0 0 1 0 1.86L12.894 14.136a1.315 1.315 0 0 1-1.86 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlack);
export default __webpack_public_path__ + "static/media/chevron-down-black.a8b46bdb.svg";
export { ForwardRef as ReactComponent };